export const isEmpty = (strToCheck?: string): boolean => {
    return strToCheck == null || strToCheck.trim() === "";
};

export const isNotEmpty = (strToCheck?: string): boolean => !isEmpty(strToCheck);
